import {colors, fonts} from '../../Styles'
import { css } from 'emotion'

const background = css`
font-family: ${fonts.primary};
padding-left: 10%;
padding-right: 10%;
margin-bottom: 15px;
line-height: 24px;
letter-spacing: 0.15px;
font-size: 18px;
`

const styles = {
    background
}

export default styles
